export default __webpack_public_path__ + "static/media/service_workshop.1a70db1b.jpg";